/**
 * EdForm组件属性
 */
export default {
    /** Data of form component */
    model: {type: Object, default: () => {}},
    /** Validation rules of form */
    rules: {type: Object, default: () => {}},
    /** Whether the form is inline */
    inline: {type: Boolean, default: false},
    /** Whether the form is disabled */
    disabled: {type: Boolean, default: false},
    /** 表单域标签的位置，如果值为 left 或者 right 时，则需要设置 label-width  right/left/top */
    labelPosition: {type: String, default: 'left'},
    /** 表单域标签的宽度，例如 '50px'。作为 Form 直接子元素的 form-item 会继承该值。支持 auto。 */
    labelWidth: {type: String, default: 'auto'},
    /** 表单域标签的后缀 */
    labelSuffix: {type: String, default: ''},
    /** Whether to show the error message */
    showMessage: {type: Boolean, default: true},
    /** Whether to display the error message inline with the form item */
    inlineMessage: {type: Boolean, default: false},
    /** Whether to display an icon indicating the validation result */
    statusIcon: {type: Boolean, default: false},
    /** Whether to trigger validation when the `rules` prop is changed */
    validateOnRuleChange: {type: Boolean, default: true},
    /** Controls the size of components in this form */
    size: {type: String, default: 'small'},
    // 是否隐藏必填字段的标签旁边的红色星号
    hideRequiredAsterisk: {type: Boolean, default: false},
    // 表单描述
    formDesc: {type: Array, required: true},
}
